<script lang="ts">
	import type { TextureMetadata, MaterialMetadata } from '$lib/textureShowcaseData';
	import { analytics } from '$lib/analytics';
	import { onMount } from 'svelte';
	import { logLandingBoot } from '$lib/landingBootLog';

	logLandingBoot('TextureShowcase: component script evaluated');

	export let textures: TextureMetadata[] = [];
	export let materials: MaterialMetadata[] = [];
	export let basePath: string = '/textures';
	export let width: number = 300;
	export let height: number = 200;
	export let scale: number = 100; // percentage of full resolution
	export let maxColumns: 1 | 2 | 3 = 3;
	export let loadImages: boolean = true;

	$: items = [...textures, ...materials];

	$: gridClass =
		maxColumns === 1
			? 'grid-cols-1'
			: maxColumns === 2
				? 'grid-cols-1 md:grid-cols-2'
				: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';

	let hasLoggedThumbnailUrlsEnabled = false;

	$: if (loadImages && !hasLoggedThumbnailUrlsEnabled) {
		hasLoggedThumbnailUrlsEnabled = true;
		logLandingBoot('TextureShowcase: thumbnail URLs enabled', {
			itemCount: items.length
		});
	}

	onMount(() => {
		logLandingBoot('TextureShowcase: mounted', {
			itemCount: items.length,
			basePath,
			loadImages
		});
	});
</script>

<div class="w-full grid {gridClass} gap-8">
	{#each items as item}
		<a
			href="{basePath}/{item.id}"
			class="group flex flex-col"
			on:click={() =>
				analytics.capture('view_texture_page', {
					texture_id: item.id,
					texture_title: item.title,
					style: 'style' in item ? item.style : undefined,
					model: 'model' in item ? item.model : undefined,
					thumbnail_url: item.thumbnailUrl
				})}
		>
			<div
				class="rounded overflow-hidden bg-primary-100 dark:bg-zinc-800 group-hover:opacity-75 transition-opacity"
				style:width={`${width}px`}
				style:height={`${height}px`}
				style:background-image={loadImages ? `url(${item.thumbnailUrl})` : undefined}
				style:background-repeat="repeat"
				style:background-size={`${scale}%`}
			></div>
			<div class="mt-2 text-xs text-zinc-700 dark:text-zinc-300">
				{item.title}
			</div>
		</a>
	{/each}
</div>
